import roles from '@/json/roles.json';

/**
 * @param {String} roleName role 英文名
 * @return {Number} roleId
 */
const convertRole2RoleId = (roleName) => {
  return roles[roleName]?.id || -1;
};

/**
 * @param {String} roleId roleId
 * @return {String} roleName
 */
const convertRoleId2Role = (roleId) => {
  const mapRole = Object.values(roles).find((role) => {
    return role.id === Number(roleId);
  });
  return mapRole?.role || '';
};

/**
 * @param {String} roleId roleId
 * @return {String} roleName
 */
const convertRoleId2Text = (roleId) => {
  const mapRole = Object.values(roles).find((role) => {
    return role.id === Number(roleId);
  });
  return mapRole?.text || '';
};

/**
 * @param {String} roleId roleId
 * @return {String} roleName
 */
const getRoleData = (roleId) => {
  const mapRole = Object.values(roles).find((role) => {
    return role.id === Number(roleId);
  });
  return mapRole || {};
};

/**
 * @param {String} roleId roleId
 * @return {String} roleName
 */
const getRolePermission = (roleId) => {
  const mapRole = Object.values(roles).find((role) => {
    return role.id === Number(roleId);
  });
  return mapRole?.permission || {};
};

/**
 * @return {String} roleName
 */
const getAdminSelectableRoles = () => {
  return Object.values(roles).filter((role) => {
    return [2, 3, 7].includes(role.id);
  });
};

/**
 * @return {String} roleId
 */
const getAgencySelectableRoles = () => {
  return Object.values(roles).filter((role) => {
    return [5, 6, 7].includes(role.id);
  });
};

export {
  convertRole2RoleId,
  convertRoleId2Role,
  convertRoleId2Text,
  getRoleData,
  getRolePermission,
  getAdminSelectableRoles,
  getAgencySelectableRoles,
};
